import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import { SIZES } from '../helper';
const rotate = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const Root = styled.span.withConfig({
  displayName: "Spinner__Root",
  componentId: "jr2shg-0"
})(["", " will-change:transform;width:32px;height:32px;overflow:hidden;animation:", " 1s linear infinite;", " ", ""], ScopedCssBaseline, rotate, ({
  size
}) => size === SIZES.SM && css(["width:24px;height:24px;"]), ({
  size
}) => size === SIZES.LG && css(["width:48px;height:48px;"]));

var _ref = /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 200 107 a 100 100 90 1 1 -1 -20 l -24 2 A 75 75 90 1 0 176 107 z"
}));

var _ref2 = /*#__PURE__*/React.createElement("filter", {
  id: "prefix__b",
  x: 0,
  y: 0
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 3
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#prefix__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#prefix__b)",
  transform: "rotate(-6 100 100)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.03,
  transform: "rotate(12 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.07,
  transform: "rotate(24 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.1,
  transform: "rotate(36 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.14,
  transform: "rotate(48 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.17,
  transform: "rotate(60 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.2,
  transform: "rotate(72 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.24,
  transform: "rotate(84 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.28,
  transform: "rotate(96 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.31,
  transform: "rotate(108 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.34,
  transform: "rotate(120 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.38,
  transform: "rotate(132 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.41,
  transform: "rotate(144 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.45,
  transform: "rotate(156 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.48,
  transform: "rotate(168 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.52,
  transform: "rotate(180 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.55,
  transform: "rotate(192 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.59,
  transform: "rotate(204 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.62,
  transform: "rotate(216 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.66,
  transform: "rotate(228 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.69,
  transform: "rotate(240 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.7,
  transform: "rotate(252 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.72,
  transform: "rotate(264 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.76,
  transform: "rotate(276 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.79,
  transform: "rotate(288 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.83,
  transform: "rotate(300 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.86,
  transform: "rotate(312 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.93,
  transform: "rotate(324 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  fillOpacity: 0.97,
  transform: "rotate(336 100 100)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c",
  transform: "rotate(348 100 100)"
})));

const Base = styled(({
  dark,
  color: defaultColor
}) => {
  const color = defaultColor ? defaultColor : dark ? 'var(--color-white)' : 'var(--color-primary-60)';
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 200 200"
  }, /*#__PURE__*/React.createElement("defs", null, _ref, _ref2, /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M250 100a150 150 0 01-3.28 31.19L100 100z",
    fill: color
  })), _ref3);
}).withConfig({
  displayName: "Spinner__Base",
  componentId: "jr2shg-1"
})([""]);
const Spinner = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    size,
    dark,
    color
  } = _ref4,
      rest = _objectWithoutPropertiesLoose(_ref4, ["size", "dark", "color"]);

  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref,
    size: size,
    role: "status",
    "aria-label": "Loading"
  }), /*#__PURE__*/React.createElement(Base, {
    dark: dark,
    color: color
  }));
});
Spinner.displayName = 'Spinner';
Spinner.sizes = {
  sm: SIZES.SM,
  md: SIZES.MD,
  lg: SIZES.LG
};
Spinner.defaultProps = {
  size: Spinner.sizes.md,
  dark: false,
  color: null
};
Spinner.propTypes = {
  size: PropTypes.oneOf([Spinner.sizes.sm, Spinner.sizes.md, Spinner.sizes.lg]),
  dark: PropTypes.bool,
  color: PropTypes.string
};
export default Spinner;